import { createSelector } from 'reselect';

import { getLanguageByLocale } from './getLanguageByLocale';
import { selectLanguages } from './selectLanguages';
import { selectLocale } from './selectLocale';

export const selectLanguage = createSelector([selectLanguages, selectLocale], (languages, locale) =>
  getLanguageByLocale(languages, locale),
);
